import { render, staticRenderFns } from "./UserFormPartList.vue?vue&type=template&id=0057b085&"
import script from "./UserFormPartList.vue?vue&type=script&lang=js&"
export * from "./UserFormPartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports